import { HTTP } from '../../../http-common';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';
import { FinanceApplication } from '../../../models/FinanceApplication';
import { FinanceApplicationEmail } from '../../../models/FinanceApplicationEmail';

const state = {
  applications: [new FinanceApplication()],
};
const getters = {
  getField,
};
const mutations = {
  setApplications(state, applications) {
    state.applications.length = 0;
    applications.forEach((data) => {
      state.applications.push(data);
    });
  },
  setProgress(state, message) {
    state.message = message;
  },
  setFinanceApplication(state, index, application) {
    state.applications[index] = application;
  },
  updateField,
};

const actions = {
  reset({ commit }) {
    commit('setApplications', [new FinanceApplication()]);
    commit('setProgress', new httpError());
  },
  getFinanceApplication({ dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      let currentOrderID = rootState.orders.rows[0].orderID;
      var response = HTTP.get('order/GetFinanceApplication/' + currentOrderID);
      response
        .then(function (data) {
          let applications = data.data;
          // commit("setApplications", applications);
          resolve(applications);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in getting application : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getOrderGUID({ dispatch }, finOrderID) {
    return new Promise((resolve, reject) => {
      HTTP.get('order/GetOrderGUIDFromFinApp/' + finOrderID)
        .then(function (data) {
          if (data.status == 200) resolve(data.data);
          else reject('No Content');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in getting application : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getFinanceApplicationFromGUID({ dispatch }, guid) {
    return new Promise((resolve, reject) => {
      HTTP.get('order/GetFinanceApplicationGUID/' + guid)
        .then(function (data) {
          if (data.status == 200) resolve(data.data);
          else reject('No Content');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in getting application : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  populateApplication({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      if (typeof payload.application == 'undefined') {
        reject('no data available');
        return;
      }
      let request = {
        template: {
          name: 'FinanceApplication',
          recipe: payload.isPDF ? 'chrome-pdf' : 'phantom-image',
          engine: 'handlebars',
          waitForJS: true,
        },
        data: payload.application,
      };

      HTTP.post('Report/Generate', request, { responseType: 'arraybuffer' })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: payload.isPDF ? 'application/pdf' : 'image/png',
          });

          resolve(blob);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  isDealer({ rootState }) {
    return rootState.orders.dealer.dealer.dealerID;
  },
  getCustomerAddresses({ rootState }) {
    return rootState.orders.address.addresses;
  },

  addAddresses({ rootState }, address) {
    rootState.orders.address.addresses.push(address);
  },
  sendEmailToCustomer({ rootState, dispatch }, datapacket) {
    return new Promise((resolve, reject) => {
      var packedApp = new FinanceApplicationEmail();

      packedApp.orderID = rootState.orders.rows[0].orderID;
      packedApp.index = datapacket.index;

      packedApp.url = datapacket.url;
      packedApp.comments = '';

      packedApp.application = new FinanceApplication();
      packedApp.application.orderID = rootState.orders.rows[0].orderID;

      packedApp.application = datapacket.details;
      packedApp.application.dealerID = rootState.orders.dealer.dealer.dealerID;

      HTTP.post('Order/SendApplicationEmailtoCustomer/', packedApp)
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Finance Application saved, sent to customer',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Financing failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  sendSMSToCustomer({ rootState, dispatch }, datapacket) {
    return new Promise((resolve, reject) => {
      var packedApp = new FinanceApplicationEmail();

      packedApp.orderID = rootState.orders.rows[0].orderID;
      packedApp.index = datapacket.index;

      packedApp.url = datapacket.url;
      packedApp.comments = '';

      packedApp.application = new FinanceApplication();
      packedApp.application.orderID = rootState.orders.rows[0].orderID;

      packedApp.application = datapacket.details;
      packedApp.application.dealerID = rootState.orders.dealer.dealer.dealerID;

      HTTP.post('Order/SendApplicationSMStoCustomer/', packedApp)
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Finance Application saved, sent to customer',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Financing failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  approveApplicationCustomer({ rootState, dispatch }, application) {
    return new Promise((resolve, reject) => {
      var message = new FinanceApplicationEmail();

      message.orderID = application.orderID;
      message.index = 0;
      message.url = '';
      message.comments = '';
      message.application = application;

      HTTP.post('Order/ApproveFinanceApplication/', message)
        .then(() => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Finance Application saved, sent to customer',
              httpStatus: 200,
            })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Financing failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },
  rejectApplicationCustomer({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      var message = new FinanceApplicationEmail();

      message.orderID = data.app.orderID;
      message.index = 0;
      message.url = '';
      message.comments = data.changes;
      message.application = data.app;

      HTTP.post('Order/RejectFinanceApplication/', message)
        .then(() => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Message has been sent to the dealer',
              httpStatus: 200,
            })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Message to dealer failed: ' + err.message,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },
  updateFinanceApplication({ rootState, dispatch }, datapacket) {
    return new Promise((resolve, reject) => {
      var packedApp = new FinanceApplication();
      packedApp.financeApplicationID = datapacket.id;
      packedApp.orderID = rootState.orders.rows[0].orderID;
      packedApp.financeApplicationDetails = datapacket.details;
      packedApp.dealerID = rootState.orders.dealer.dealer.dealerID;

      var response = HTTP.post('Order/UpdateFinancing/', packedApp);
      response
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Finance Application saved',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Financing failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  generateFinanceApplication({ commit, rootState, dispatch }, financeID) {
    var response = HTTP.post(
      'Order/GenerateFinanceApplication/' +
        rootState.orders.rows[0].orderID +
        '/' +
        financeID
    );
    response
      .then(function (data) {
        commit('setApplications', [data.data]);
        dispatch(
          'setMessage',
          new httpError({
            message: 'Message Sent',
            httpStatus: 200,
          })
        );
      })
      .catch((err) => {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Financing failed : ' + err.message,
            httpStatus: 500,
          })
        );
      });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  createNewApplication({ commit, rootState, dispatch }) {
    var response = HTTP.post(
      'Order/CreateNewFinancialApplication/' + rootState.orders.rows[0].orderID
    );
    response
      .then(function (data) {
        let applications = data.data;
        commit('setApplications', applications);
        dispatch(
          'setMessage',
          new httpError({
            message: 'New Application Created',
            httpStatus: 200,
          })
        );
      })
      .catch((err) => {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Creating New Application Failed : ' + err.message,
            httpStatus: 500,
          })
        );
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
